import React from 'react';
import PhotovoltaicApplicationForm from './PhotovoltaicApplicationForm';

function App() {
  return (
    <div className="App">
      <PhotovoltaicApplicationForm />
    </div>
  );
}

export default App;
